import { render, staticRenderFns } from "./posting.vue?vue&type=template&id=0dbb4595&scoped=true&"
import script from "./posting.vue?vue&type=script&lang=js&"
export * from "./posting.vue?vue&type=script&lang=js&"
import style0 from "./posting.vue?vue&type=style&index=0&id=0dbb4595&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb4595",
  null
  
)

export default component.exports